import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="w-full bg-card border-t border-border px-8 lg:px-16 py-10">
      <div className="flex flex-col gap-6">
        <Link to="/" className="font-[var(--font-primary)] text-base font-bold text-foreground no-underline">
          ACTRESS DB
        </Link>
        <div className="flex items-center justify-between">
          <p className="font-[var(--font-secondary)] text-xs text-muted-foreground">
            &copy; 2026 ACTRESS DB. All rights reserved.
          </p>
          <p className="font-[var(--font-secondary)] text-xs text-muted-foreground">
            Powered by <a href="https://affiliate.dmm.com/api/" className="text-muted-foreground hover:text-foreground no-underline">FANZA Webサービス</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
